import { NgForOf, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-near-me',
  standalone: true,
  imports: [NgIf, NgForOf, TranslateModule],
  templateUrl: './near-me.component.html',
})
export class NearMeComponent {
  @Input() items: any[] = [];
  @Input() areItemsSelected = false;
  @Output() itemSelected: EventEmitter<any> = new EventEmitter<any>();

  selectItem(item: any): void {
    this.itemSelected.emit(item);
  }
}
